import { Delete, JoinFull } from '@mui/icons-material';
import {
  Button,
  ButtonGroup,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from '@mui/material';
import { chain } from 'lodash';
import { Zone } from '@helpers/types.ts';

interface IZonesDetailProps {
  zones: Array<Zone>;
  focusZone: (zone: string) => void;
  onDeleteZone: (zone: Zone) => void;
  onCombine: () => void;
}

const ZonesDetail = (props: IZonesDetailProps) => {
  if (props.zones.length === 0) return <></>;

  return (
    <div className="flex flex-1 overflow-hidden flex-col">
      <List
        dense
        className="flex-1 overflow-auto"
        subheader={
          <ListSubheader component="div">Zonas de entrega</ListSubheader>
        }
      >
        {chain(props.zones)
          .sortBy((z) => z.name)
          .map((zone) => (
            <ListItem
              key={`${zone._id}`}
              secondaryAction={
                <ButtonGroup
                  color="secondary"
                  variant="text"
                  fullWidth
                  size="small"
                >
                  <Button
                    onClick={() => {
                      props.onDeleteZone(zone);
                    }}
                    startIcon={<Delete />}
                  ></Button>
                </ButtonGroup>
              }
              disablePadding
            >
              <ListItemButton
                onClick={() => {
                  props.focusZone(zone.name);
                }}
              >
                <ListItemIcon>
                  <div
                    style={{
                      width: 16,
                      height: 16,
                      border: '1px solid #555',
                      background: zone.color + '55',
                    }}
                  ></div>
                </ListItemIcon>
                <ListItemText primary={zone.name} />
              </ListItemButton>
            </ListItem>
          ))
          .value()}
      </List>
      <Divider />
      <ButtonGroup variant="text" fullWidth>
        <Button startIcon={<JoinFull />} onClick={props.onCombine}>
          Unir zonas
        </Button>
      </ButtonGroup>
    </div>
  );
};
export default ZonesDetail;
